import * as React from "react";
import Button from "@mui/material/Button";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Login/style.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Stepper, Step, StepLabel, Box, Typography, Grid } from "@mui/material";
import { Formik, Form } from "formik";
import { ProgramForm } from "./form/ProgramForm";
import { CommitmentForm } from "./form/CommitmentForm";
import { useErrorHandler } from "../../hooks";
import { PreviewForm } from "./form/PreviewForm";
import { useSelector } from "react-redux";
import { CLEAR_PROGRAM_SUCCESS } from "../../Redux/Actions/ProgramAction";
import { useDispatch } from "react-redux";
import HelmetReact from "../../Components/Helmet";
import { useLocation } from "react-router-dom";
const CreateProgram = ({ open, setOpen }) => {
  const { isEdit } = useSelector((state) => state?.Program);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [formValue, setFormValue] = useState("");
  const setStepOneData = (value) => {
    setFormValue(value);
    setActiveStep(activeStep + 1);
    const { programTitle } = value;
  };
  function _handleBack() {
    setActiveStep(activeStep - 1);
  }

  const goBack = () => {
    dispatch({ type: CLEAR_PROGRAM_SUCCESS });
    const tstate = location?.state;
    navigate("/programs", { state: tstate });
  };

  const steps = ["PROGRAM", "COMMITMENT", "PREVIEW"];

  function renderStepContent(step) {
    switch (step) {
      case 0:
        return <ProgramForm setStepOneData={setStepOneData} />;
      case 1:
        return (
          <CommitmentForm
            setStepOneData={setStepOneData}
            formValue={formValue}
            setFormValue={setFormValue}
            _handleBack={_handleBack}
          />
        );
      case 2:
        return <PreviewForm formValue={formValue} _handleBack={_handleBack} />;
      default:
        return <div>Not Found</div>;
    }
  }

  const [activeStep, setActiveStep] = useState(0);
  const isLastStep = activeStep === steps.length - 1;

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function _submitForm(values, actions) {
    await _sleep(1000);
    alert(JSON.stringify(values, null, 2));
    actions.setSubmitting(false);
    setActiveStep(activeStep + 1);
  }

  function _handleSubmit(values, actions) {
    if (isLastStep) {
      _submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  return (
    <>
      <HelmetReact name="Program" />
      <Box className="d-details-box">
        <Typography className="web-title">
          {isEdit ? "UPDATE PROGRAM" : "CREATE PROGRAM"}
        </Typography>
        <Grid container spacing={2}>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <button onClick={() => goBack()} className="back-btn">
              <ArrowBackIosIcon
                size="large"
                edge="start"
                aria-label="menu"
                sx={{ mr: 2, color: "grey", flexGrow: 0, cursor: "pointer" }}
              />
            </button>
          </Grid>
        </Grid>

        <Box sx={{ my: 2 }}>
          <Stepper activeStep={activeStep} className="mb-5">
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <React.Fragment>
            {activeStep === steps.length ? (
              <div>Finish</div>
            ) : (
              <div>
                {renderStepContent(activeStep)}
                <div>
                  <div></div>
                </div>
              </div>
            )}
          </React.Fragment>
        </Box>
      </Box>
    </>
  );
};

export default CreateProgram;
